export const GROUPED_MULTI_OPTION = "multi_select";
export const SINGLE_CHOICE_MULTI_OPTION = "single_select";
export const SINGLE_CHOICE_BINARY_OPTION = "binary";
export const QUES_TYPE_SELECT = "drop_down";
export const QUES_TYPE_NUMBER = "number";
export const QUES_TYPE_NUMBER_ARRAY = "number_array";
export const QUES_TYPE_STRING = "string";
export const QUES_TYPE_STRING_ARRAY = "string_array";
